module.exports = __webpack_public_path__ + "static/media/15k.a893b422.webp";